/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportsExportJobIdDownloadGet$Json$Params {
  exportJobId: string;
}

export function exportsExportJobIdDownloadGet$Json(http: HttpClient, rootUrl: string, params: ExportsExportJobIdDownloadGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportsExportJobIdDownloadGet$Json.PATH, 'get');
  if (params) {
    rb.path('exportJobId', params.exportJobId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportsExportJobIdDownloadGet$Json.PATH = '/exports/{exportJobId}/download';
